exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".AddAnnotationDialog-b2913898 .lessMargin-6d7368c3{margin:0 0 20px 0}.AddAnnotationDialog-b2913898 .successMessage-f895b308{text-align:center}\n", ""]);

// Exports
exports.locals = {
	"AddAnnotationDialog": "AddAnnotationDialog-b2913898",
	"lessMargin": "lessMargin-6d7368c3",
	"successMessage": "successMessage-f895b308"
};